// @ts-nocheck
export const objectHelper = {
  removeEmptyValues: <T>(object: T): T => {
    const toReturn = { ...object };
    const keys = Object.keys(object) as (keyof T)[];

    keys.forEach((key) => {
      const value = object[key];

      if (typeof value === 'string' && value === '') {
        delete toReturn[key];
      }
    });

    return toReturn;
  },
  removeByKeys: <T>(keys: (keyof T)[], object: T): T => {
    const toReturn = { ...object };

    keys.forEach((key) => {
      delete toReturn[key];
    });

    return toReturn;
  },
};
